import React from 'react';

export default function Permit({ permit }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });

    let logList = (<table id="permitSummary" className="permitTbl">
        <thead>
            <tr>
                <th colSpan="2">
                    {permit.identifier}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr><td>Permittee</td><td></td></tr>
            <tr><td>Total Site Acreage</td><td>{permit.totalAcreage}</td></tr>
            <tr><td>Disturbed Acreage</td><td>{permit.disturbedAcreage}</td></tr>
            <tr><td>Cumulative Permitted Acreage (Includes NOCs)</td><td></td></tr>
            <tr><td>NOI Submittal Date</td><td>{permit.noiSubmittalDate && dateFormatter.format(new Date(permit.noiSubmittalDate))}</td></tr>
            <tr><td>NOI Authorization Date</td><td>{permit.noiAuthorizationDate && dateFormatter.format(new Date(permit.noiAuthorizationDate))}</td></tr>
            <tr><td>Authorization Expiration Date</td><td>{permit.noiAuthorizationExpDate && dateFormatter.format(new Date(permit.noiAuthorizationExpDate))}</td></tr>
            <tr><td>NOT Submittal Date</td><td>{permit.notSubmittalDate && dateFormatter.format(new Date(permit.notSubmittalDate))}</td></tr>
            <tr><td>NOT Approval Date</td><td>{permit.notApprovalDate && dateFormatter.format(new Date(permit.notApprovalDate))}</td></tr>
            <tr><td colSpan="2">
                Comments:
                <div className="comments"></div>
            </td></tr>
        </tbody>
    </table>);

    let logTypeNameDescription = (<div className="logType">
        <div className="flexbox-flex align-start overflow-x-hidden">
            <span className="nameContainer">
                <span className="name">{permit.identifier}</span>
            </span>
        </div>
    </div>);

    return (
        <div id="permitSummary1" className="logTypeContainer">
            {logList}
        </div>
    );
}